module.exports = __webpack_public_path__ + "static/media/1 41 fullt.bed07ad6.mp3";